import { render, staticRenderFns } from "./SiteRouteEditModal.vue?vue&type=template&id=874f5b38"
import script from "./SiteRouteEditModal.vue?vue&type=script&lang=js"
export * from "./SiteRouteEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports